<template>
    <div class="left_panel team_detail-page">
        <div class="main_heading d-flex align-items-center pb_22">
            <div class="main_heading_img">
                <img
                    :src="
                        team_data.logo_file
                            ? team_data.logo_file
                            : '/maincss/images/fc_united_img.png'
                    "
                    alt=""
                />
            </div>
            <div class="main_heading_text ml_36">
                <h1 class="font_size_26 font-weight-bold">
                    {{ team_data.name | capitalize }}
                </h1>
                <p class="font_size_18">
                    Coach/Team Lead:
                    {{ team_data.coach.first_name | capitalize }}
                    {{ team_data.coach.last_name | capitalize }}
                </p>
            </div>
        </div>
        <div
            class="panel_head_wrap team_panel_wrap d-flex align-items-end justify-content-between mt_36"
        >
            <div class="panel_heading">
                <h2 class="font_size_20">Team Members</h2>
            </div>
            <div
                class="panel_head_right upload_img_panel d-flex align-items-center"
            >
                <div
                    class="pl_8 py_6"
                    v-if="grid_view"
                    v-tooltip="'Go to list view'"
                >
                    <span
                        ><a href="javascript:void(0)" @click="grid_view = false"
                            ><img
                                alt=""
                                src="/maincss/images/icons/threelines.svg" /></a
                    ></span>
                </div>
                <div
                    class="delet_icon pl_18"
                    v-else
                    v-tooltip="'Go to grid view'"
                >
                    <span class="bin_icon"
                        ><a href="javascript:void(0)" @click="grid_view = true"
                            ><img
                                alt=""
                                src="/maincss/images/icons/boxes.svg" /></a
                    ></span>
                </div>
            </div>
        </div>
        <div class="team_member_wrap" v-if="team_data.player">
            <div class="row" v-if="grid_view">
                <div
                    class="col-md-6 col-lg-4 col-xl-3"
                    v-for="(player, index) in team_data.player"
                    :key="index"
                >
                    <div class="team_member_box px_16 pt_16 pb_18 mb_30">
                        <div
                            class="team_img_name d-flex align-items-center mb_8"
                        >
                            <div class="team_img">
                                <span class="font_size_18 font-weight-bold">{{
                                    player.short_form
                                }}</span>
                            </div>
                            <div class="team_text ml_6">
                                {{ player.full_name | capitalize }}
                            </div>
                        </div>
                        <div class="icon_text text_icon_captilize mb_14 ml_8">
                            <span
                                ><img
                                    alt=""
                                    src="/maincss/images/icons/placeholder.svg" /></span
                            ><span class="font_size_12 pl_6">{{
                                player.Profile.city
                            }}</span>
                        </div>
                        <div class="icon_text mb_14 ml_8">
                            <span
                                ><img
                                    alt=""
                                    src="/maincss/images/icons/envelope.svg" /></span
                            ><span class="font_size_14 pl_6">
                                <a :href="'mailto:' + player.email">
                                    {{ player.email }}</a
                                ></span
                            >
                        </div>
                        <div class="icon_text mb_14 ml_8">
                            <span
                                ><img
                                    alt=""
                                    src="/maincss/images/icons/call.svg" /></span
                            ><span class="font_size_14 pl_6"
                                ><a :href="'tel:' + player.mobile">{{
                                    player.mobile
                                }}</a></span
                            >
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-12 mt_30" v-else>
                <div
                    class="custome_table_width account_table manage_player_table table-responsive pl_10 pr_10 mt_30 mb_50 semibold-table"
                >
                    <table class="table mb_0">
                        <thead>
                            <tr>
                                <th class="sort">Name</th>
                                <th class="sort">Location</th>
                                <th class="sort">Email</th>
                                <th scope="sort">Phone</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                v-for="(player, index) in team_data.player"
                                :key="index"
                            >
                                <td>{{ player.full_name | capitalize }}</td>
                                <td>{{ player.Profile.city }}</td>
                                <td>
                                    <a :href="'mailto:' + player.email">
                                        {{ player.email }}</a
                                    >
                                </td>
                                <td>{{ player.mobile }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="team_member_btn">
                <router-link :to="{ name: 'ManageTeam' }">
                    <a
                        href="javascript:void(0)"
                        class="btn btn_orange bg_primary_orange text_white ml_20 pt_22 pb_22 pr_54 pl_54"
                    >
                        Back to listing
                    </a>
                </router-link>
            </div>
        </div>
    </div>
</template>
<script>
import ApiService from "@/common/api.service";

export default {
    name: "TeamMember",
    data() {
        return {
            team_data: {},
            grid_view: true
        };
    },
    mounted() {
        if (this.$route.params.id != undefined) {
            this.getTeamData(this.$route.params.id);
        }
    },
    filters: {
        capitalize: function (value) {
            if (!value) {
                return "";
            }
            return value.charAt(0).toUpperCase() + value.slice(1);
        }
    },
    methods: {
        getTeamData(id) {
            var _this = this;
            new Promise(() => {
                ApiService.get("/teams/" + id)
                    .then(({ data }) => {
                        _this.team_data = data.team;
                        _this.team_data.player = _this.team_data.player.map(
                            (elemet) => {
                                elemet.short_form =
                                    _this.getShortFormEachWordString(
                                        elemet.full_name
                                    );
                                return elemet;
                            }
                        );
                    })
                    .catch(({ response }) => {
                        console.log(response.status);
                    });
            });
        },
        getShortFormEachWordString(full_name) {
            full_name = full_name.match(/\b(\w)/g);
            return full_name[0].toUpperCase() + full_name[1].toUpperCase();
        }
    }
};
</script>
